<app-header />
<div class="flex max-w-full">
  <div class="w-auto">
    <app-sidebar />
  </div>
  <div class="content w-full min-w-0">
    <router-outlet />
  </div>
</div>
